import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { Box } from '@mui/material'
import moment from 'moment';

import PageHeader from "../helper/PageHeader";
import SortedTable from "../helper/SortedTable";
import Loading from '../helper/Loading';
import * as API from '../helper/APIcalls';
import {CancelDialog} from '../helper/Dialogs';
import { authContext } from '../../context/AuthContext';
import { languages } from '../../constants/global'
import { getTrainingProviderOptions, getWorkshopData } from '../helper/APIcalls';

const headCells = [
    { id: 'Action', label: 'Action', centered: false},
    { id: 'workshopID', label: 'Class ID', sortable: true, centered: false },
    { id: 'date', label: 'Date', sortable: true, centered: false },
    { id: 'location', label: 'Location', sortable: true, centered: false },
    { id: 'status', label: 'Status', sortable: true, centered: false },
    { id: 'language', label: 'Language', sortable: true, centered: false },
    { id: 'leadInstructor', label: 'Lead Instructor', sortable: true, centered: false },
    { id: 'contact', label: 'Contact', sortable: true, centered: false }
];
const bodyCells = [
    //{ id: 'ID', label: 'ID', centered: false },
    { name: 'workshopID', centered: false },
    { name: 'date', centered: false },
    { name: 'location', centered: false },
    { name: 'status', centered: false },
    { name: 'language',  centered: false },
    { name: 'leadInstructor',  centered: false },
    { name: 'contact', centered: false }
];

const TrainingProvManage = props => {
    const [loading, setLoading] = useState(true)
    const [classes, setClasses] = useState([])
    const [cancel, setCancel] = useState({open: false, id: null, reason: ''})
    const [submitting, setSubmitting] = useState(false)

    const history = useHistory()
    const user = useContext(authContext)

    // this fixes: Can't perform a React state update on an unmounted component -  when updating state in async, use an if to make sure this is true
    const mounted = useRef(true)



    // considering wrapping this in useCallback
    async function fetchData() {
        setLoading(true)
        const classes = await API.getClassesForTrainingProv(props.match.params.id)

        // transforms data from API into table formatted
        const enhancedData = classes.map((item) => {
            // console.log("ITEM",JSON.stringify(item),"Class",item.workshopID,"waive",item.waiverNeeded)
            // console.log('training code test', item.trainingCode === null)
            // console.log('remote', item.isRemote)
            item.date = moment(item.fromDate).format('YYYY-MM-DD');
            item.location = item.isRemote ? "Live Online Session" : item.location;
            item.actionsDisabled = {
                view: false,
                allowEdit: item.status !=="Cancelled", //enable if not cancel
                allowCancel: item.status !=="Cancelled",
                allowWaiver: item.status ==="Pending", //!item.waiverNeeded, //false, 
                allowAccept: (item.isRemote && item.trainingCode !== null)

            }
            return item;
        });

        console.log(enhancedData);
        if (mounted.current) {
            setClasses(enhancedData)
            setLoading(false)

        }
    }


    useEffect(() => {
        //mount
        fetchData();

        // on unmount
        return () => {
            mounted.current = false
        }
    // eslint-disable-next-line
    }, [props.match.params.id])  


    const onAddWorkshop = () => {
        history.push({
            pathname: '/class',
            state: {
                trainingProvider: {
                    id: props.match.params.id,
                }
            }
        });
    }


    const onView = (workshopID) => {
        history.push({
            pathname: '/class/' + workshopID+'/view'
        });
    }

  
    const onEdit = (workshopID) => {

        history.push({
            pathname: '/class/' + workshopID,
            state: {
                editing: true,
            }
        });
    }


    // opens dialog
    const onCancel = (workshopID) => {
        setCancel({open: true, id: workshopID, reason: ''})
    }

    // closes dialog
    const onCancelClose = () => {
        setCancel({open: false, id: null, reason: ''})
    }

    // submits reason from dialog and reloads workshops
    const handleCancel = async () => {
        if (submitting)
            return;
        setSubmitting(true);

        let userName = user.user.username

        const options = await getTrainingProviderOptions()

        const data = await getWorkshopData(cancel.id, options, languages)

        await API.cancelWorkshop(cancel.id, cancel.reason, userName, data)

        // reloads classes so that the new status is displayed, could also just set the status from here instead of reload
        fetchData()
        setSubmitting(false)
        onCancelClose()
    }
    // handles textfield update for reason
    const handleReason = (event) => {
        event.persist()
        setCancel( prev => {return {...prev, reason: event.target.value}})
    }


    const onWaive = (workshopID) => {
        history.push({
            pathname: '/class/' + workshopID + '/waive'
        });
    }

    const onAttendees = (workshopID) => {
        console.log('workshopID', workshopID);
        console.log('classes', classes);
        const selected = classes.find(e => e.ID === workshopID)
        console.log('selected', selected);
        history.push({
            pathname: 'attendess/' + selected.trainingCode , 
            state: {
                fromDate: selected.fromDate,
                classid: selected.workshopID
             }
        });
    }


    const actionButtons = [
        { icon: "view", action: onView, delete: false },
        { icon: "edit", action: onEdit, delete: false, view:"allowEdit"},
        { icon: "cancel", action: onCancel, delete: false, view:"allowCancel"},
        { icon: "waiver", action: onWaive, delete: false, view:"allowWaiver" },
        { icon: "accept", label: 'Attendees', action: onAttendees, delete: false, view:"allowAccept"}
    ];
    const editDelete = false;

    return (
        <>
            {loading ? <Loading /> :
                <Fragment>
                    <PageHeader
                        // title={"Training Provider: " + trainingProv.name}
                        title={"Manage Classes"}
                        cancel={history.goBack}
                        actionButtons={[{ label: "Create class", action: onAddWorkshop, disabled: props.admin }]}
                    />
                    {classes.length === 0 ?
                        <Box display="flex" mt={4} justifyContent="center">
                            <h1>No classes found.</h1>
                        </Box>
                        :
                        <>
                            <SortedTable
                                data={classes}
                                cellKey={"ID"}
                                headCells={headCells}
                                bodyCells={bodyCells}
                                defaultSortKey={"name"}
                                editDelete={editDelete}
                                actionButtons={actionButtons}
                                actions={true}
                            />
                            <CancelDialog
                                open={cancel.open}
                                onClose={onCancelClose}
                                onDelete={handleCancel}
                                onChange={handleReason}
                                disabled={submitting}
                                value={cancel.reason}
                            />
                        </>
                    }
                </Fragment>}

        </>

    )
}

export default TrainingProvManage;